export default "__VITE_ASSET__Rmk8OevS__"